import { v4 as uuid } from 'uuid';

export function oauthSessionReady (data) {
    console.log('oauthSessionReady(): ', data);
    
    const env = this.env;
    // env.setSessionSettings(data.session);
    
    const appStore = env.appStore;
    setTimeout(() => {
        appStore.observed.oauthSessionReady = uuid();
    }, 50);
    
}

export default oauthSessionReady;
